/**
 * Background behind the video stage and screen-share canvas. A theme path
 * string (resolved via the MUI `sx` prop), so it follows whichever theme
 * the app is currently using. `background.default` is the same neutral
 * surface as the rest of the app's content area — see `theme.ts`.
 *
 * Override in one place if a future theme wants a different video surround
 * (e.g. `"common.black"` for an always-dark video bg, or any palette path).
 */
export const VIDEO_BG = "background.default";
